{
	"bodyText": "Healing is not available in your current browser. To use healing, please switch to Chrome or use our desktop app (recommended)."
}
